import "../liquid/highlighter";
import "ace-builds/webpack-resolver";
/**
 * @function resolveMode
 * @param  {String} ext the extension of the file
 */
export default function resolveMode(ext = "") {
  editor.getSession().setMode("ace/mode/text");
  if (ext === "js") {
    window.editor.getSession().setMode("ace/mode/javascript");
  } else if (ext === "liquid") {
    window.editor.getSession().setMode("ace/mode/liquid", () => {
      window.editor.getSession().setMode("ace/mode/volcanicLiquid");
    });
  } else if (ext !== "txt") {
    window.editor.getSession().setMode("ace/mode/" + ext);
  }
}
